import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CreateRealtimeToken as CREATE_REALTIME_TOKEN } from 'src/api/realtime.api';
import type { ApolloErrorContext } from 'src/lib/apollo/errorPresentation';
import type { CreateRealtimeToken, CreateRealtimeTokenInput, CreateRealtimeTokenVariables } from 'types/graphql';

/** `getRealtimeToken`'s identity MUST stay stable across renders — it sits in the `useCallback` deps of the token function handed to `useInngestRealtime`, and a new identity tears the socket down and drops messages. */
export function useGetRealtimeToken(options: { context?: ApolloErrorContext } = {}) {
  const [mutate, { loading, error }] = useMutation<CreateRealtimeToken, CreateRealtimeTokenVariables>(
    CREATE_REALTIME_TOKEN,
    options
  );
  const getRealtimeToken = useCallback(
    ({ variables }: { variables: CreateRealtimeTokenInput }) => mutate({ variables: { input: variables } }),
    [mutate]
  );
  return { getRealtimeToken, loading, error };
}
